// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"19":"71a473de4f157283","127":"09601cdfdb301fb0","168":"7e79316b8ba8e9c0","204":"53465f3e4cc8f74e","220":"d08959d26fcb0676","520":"7748dc8451b1bf6c","694":"03212d1c8bfa4154","747":"85fe351978816d05","907":"b9680ace6360c242"}[chunkId] + ".js";
};